export const BACKEND_KEY = 'TotalExpenses';
export const BASE_EXPENSE = {
  Amount: null,
};
